// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__6QQZx","pageContent":"PageLayout_pageContent__Ma-pE","headerContainer":"PageLayout_headerContainer__w2IAI"};